import ChevronRight from "@mui/icons-material/ChevronRight";
import Button, { type ButtonProps } from "@mui/material/Button";
import { useTranslation } from "react-i18next";

export function NextButton({ children, ...props }: ButtonProps) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:NextButton",
  });
  return (
    <Button variant="outlined" endIcon={<ChevronRight />} {...props}>
      {children || t("buttonText")}
    </Button>
  );
}
